export const removeStyleAttribute = (style: string, attributeName: string) => {
  if (!style || !attributeName || style.indexOf(attributeName) < 0)
    return style || "";

  const regex = new RegExp(attributeName + ":\\s*[^;]+;?\\s*", "g");

  return style.replace(regex, "");
};
